import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Timer, Zap, HeartHandshake } from 'lucide-react';
export function Protocol() {
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-197">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30" data-id="element-198">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-gold-200 rounded-full blur-3xl" data-id="element-199"></div>
        <div className="absolute top-40 -left-40 w-96 h-96 bg-sage-200 rounded-full blur-3xl" data-id="element-200"></div>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-201">
        <FadeIn data-id="element-202">
          <div className="text-center mb-16" data-id="element-203">
            <span className="text-gold-600 font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-204">
              El Secreto
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-205">
              El Protocolo de Interrupción de 7 Segundos
            </h2>
            <p className="text-xl text-warmBrown-700 max-w-2xl mx-auto leading-relaxed" data-id="element-206">
              Este método no se basa en psicología abstracta, sino en
              neurociencia pura aplicada a tu día a día.
            </p>
          </div>
        </FadeIn>

        <div className="bg-white rounded-3xl shadow-xl border border-cream-200 p-8 md:p-12" data-id="element-207">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-208">
            <FadeIn delay={0.1} className="text-center" data-id="element-209">
              <div className="w-20 h-20 mx-auto bg-sage-50 rounded-full flex items-center justify-center mb-6 border-4 border-sage-100" data-id="element-210">
                <Timer className="w-10 h-10 text-sage-600" data-id="element-211" />
              </div>
              <h3 className="text-xl font-bold mb-3 font-heading text-terracotta" data-id="element-212">
                El Segundo Exacto
              </h3>
              <p className="text-warmBrown-600" data-id="element-213">
                Aprenderás a identificar el momento preciso antes de la
                explosión para hackear tu respuesta cerebral.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} className="text-center" data-id="element-214">
              <div className="w-20 h-20 mx-auto bg-gold-50 rounded-full flex items-center justify-center mb-6 border-4 border-gold-100" data-id="element-215">
                <Zap className="w-10 h-10 text-gold-600" data-id="element-216" />
              </div>
              <h3 className="text-xl font-bold mb-3 font-heading text-terracotta" data-id="element-217">
                De Reacción a Liderazgo
              </h3>
              <p className="text-warmBrown-600" data-id="element-218">
                En lugar de reaccionar desde el miedo o el enojo, aprenderás a
                responder desde el liderazgo y la calma.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} className="text-center" data-id="element-219">
              <div className="w-20 h-20 mx-auto bg-terracotta-50 rounded-full flex items-center justify-center mb-6 border-4 border-terracotta-100" data-id="element-220">
                <HeartHandshake className="w-10 h-10 text-terracotta-600" data-id="element-221" />
              </div>
              <h3 className="text-xl font-bold mb-3 font-heading text-terracotta" data-id="element-222">
                Cambio de Frecuencia
              </h3>
              <p className="text-warmBrown-600" data-id="element-223">
                Al cambiar tu frecuencia, obligas al cerebro de tu hijo a salir
                del modo berrinche y entrar en modo escucha.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}